import Hero from "../components/home/Hero";
import CoreProposition from "../components/home/CoreProposition";
import DeliveryModels from "../components/home/DeliveryModels";
import RushHourShowcase from "../components/home/RushHourShowcase";
import WhatWeBuild from "../components/home/WhatWeBuild";
import WhoWeServe from "../components/home/WhoWeServe";
import HowItWorks from "../components/home/HowItWorks";
import PricingSection from "../components/home/PricingSection";
import Ownership from "../components/home/Ownership";
import LiveShowcase from "../components/home/LiveShowcase";
import CaseStudiesSection from "../components/home/CaseStudiesSection";
import TechSection from "../components/home/TechSection";
import FaqSection from "../components/home/FaqSection";
import FinalCta from "../components/home/FinalCta";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <CoreProposition />
      <DeliveryModels />
      <RushHourShowcase />
      <WhatWeBuild />
      <WhoWeServe />
      <HowItWorks />
      <PricingSection />
      <Ownership />
      <LiveShowcase />
      <CaseStudiesSection />
      <TechSection />
      <FaqSection />
      <FinalCta />
    </div>
  );
}
